import React, { useEffect, useState } from 'react';

import { useSearch } from '~libs/searchParams';

import { Button, ClickableIcon, Toolbar } from '~components';
import { SearchBar } from '~components/form-fields/search';
import Icon, { faMagnifyingGlass, faPlus } from '~components/icon';
import { TableView } from '~components/table-view-v3';

import columnsFactory from '~support-at-home/forms/reconciliations/list';
import { searchFields } from '~support-at-home/forms/reconciliations/search';

import { setTitle } from '~main/actions/login';
import { useGetReconciliationsQuery } from '~support-at-home/actions/reconciliations';

import EditReconModal from './EditRecon';
import ReconciliationsWizard from './reconciliations-wizard';

const Reconciliations: React.FC<{ isActive: boolean }> = ({ isActive }) => {
  const [searchBarOpen, setSearchBarOpen] = useState<boolean>(false);
  const [searchParams, setSearchParams] = useSearch('reconciliations-search', {});
  const search = (values: Record<string, any>) => setSearchParams(values);

  const [wizardOpen, setWizardOpen] = useState<boolean>(false);
  const [editReconModalOpen, setEditReconModalOpen] = useState<boolean>(false);
  const [editReconId, setEditReconId] = useState<string>('');

  useEffect(() => {
    if (isActive) {
      setTitle('Reconciliations');
    }
  }, [isActive]);

  // RTK Hook
  const { data: reconciliations = [], isFetching: isLoading, refetch } = useGetReconciliationsQuery(searchParams);

  const toggleEditRecon = (toggle = true, id = '') => {
    setEditReconId(id);
    setEditReconModalOpen(toggle);
    if (!toggle) refetch();
  };

  const columns = columnsFactory((id) => toggleEditRecon(true, id));

  return (
    <div className="p-2 reconciliations">
      <Toolbar
        id="reconciliations"
        rightCluster={
          <>
            <ClickableIcon
              className="me-2"
              icon={faMagnifyingGlass}
              id="reconciliations-search-button"
              onClick={() => setSearchBarOpen(!searchBarOpen)}
              toolTip="Toggle Search Bar"
            />
            <Button dataCy="reconciliations-new-button" size="sm" color="success" onClick={() => setWizardOpen(true)}>
              <Icon className="me-2" icon={faPlus} />
              New
            </Button>
          </>
        }
      />
      <SearchBar isOpen={searchBarOpen} fields={searchFields} initialValues={searchParams} onSubmit={search} />
      <TableView
        id="reconciliations-table"
        columns={columns}
        data={reconciliations}
        isLoading={isLoading}
        emptyMessage="No reconciliations found"
        readonly
        striped
      />
      <ReconciliationsWizard isOpen={wizardOpen} setIsOpen={setWizardOpen} />
      <EditReconModal isOpen={editReconModalOpen} setIsOpen={toggleEditRecon} id={editReconId} />
    </div>
  );
};

export default Reconciliations;
